import * as React from 'react';

import { WrappedFC } from '../shared/types';

interface Props {
  /** 表示するコンポーネントの種類 */
  type: 'separator' | 'verticalSeparator';
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';

/**
 * セパレータコンポーネント
 */
export const Separator: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type = 'separator',
  className,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _clsName = className || type;
  return (
    <Element {...props} className={_clsName}>
      {props.children}
    </Element>
  );
};
Separator.displayName = 'Separator';
